export const DOCUMENTATION_URLS = {
  home: "https://ngit.dev/",
  install: "https://ngit.dev/install",
  quickstart: "https://ngit.dev/quickstart",
  gitworkshop: "https://ngit.dev/gitworkshop/",
  grasp: "https://ngit.dev/reference/grasp",
  selfHostGrasp: "https://ngit.dev/self-host/ngit-grasp",
} as const;
